import React, { useState } from 'react'
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { getGoogleInitArgs } from '../../v2_actions/map'
import {
  Box,
  Input} from '@mui/material'
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import { setSelectedGallery } from "../../actions/gallery";
import { StyledButton } from "../../components/CustomButtons/StyledButton";

const useStyles = makeStyles((theme) => ({
  mapContainer: {
    top: '10px',
    left: '20%',
    width: '80%',
    margin: 'auto',
    textAlign: 'center',
    position: 'absolute'
  },
  mapInput: {
    height: 30,
    fontSize: 12,
    width: '40%',
    zIndex: 9900,
    color: '#000',
    border: 'none',
    outline: 'none',
    fontWeight: 400,
    borderRadius: 20,
    padding: '0 10px',
    background: '#fff',
    boxSizing: 'border-box',
    textOverflow: `ellipses`,
    border: '1px solid transparent',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
  },
  container: {
    top: '10px',
    left: '10%',
    width: '70%',
    margin: 'auto',
    textAlign: 'center'
  },
  input: {
    fontSize: 12,
    zIndex: 9900,
    width: '150%',
    height: `35px`,
    outline: `none`,
    height: '26px',
    borderRadius: 8,
    fontSize: `14px`,
    padding: `0 12px`,
    fontWeight: '800',
    color: 'rgb(0 0 0)',
    padding: '4px  8px',
    boxSizing: `border-box`,
    textOverflow: `ellipses`,
    border: `2px solid black`
  },

  wrapper: {
    p: 1.5,
    display: 'flex',
    justifyContent: 'space-between'
  },
  mainTitle: {
    width: "100px",
    height: "36px",
    color: "#000000",
    display: 'contents',
    fontFamily: "Raleway",
    fontWeight: "800",
    fontSize: "24px",
    textAlign: "left",
    paddingLeft: "15px",
    paddingTop: "5px",
  },
  searchBox: {
    width: '262px',
    height: '26px',
    fontSize: '12px',
    color: '#000000',
    fontWeight: '400',
    textAlign: 'left',
    padding: '4px 8px 4px 8px',
    '& .MuiInputBase-root': {
      height: '26px',
      padding: '9px 5px 0px'
    },
    '&&&&& input': {
      padding: '0',
    },
    '&&&& ::placeholder': {
      color: '000000',
      opacity: 1 /* Firefox */,
      fontSize: '12px',
      fontWeight: '500',
    },
  },
}))

export const AddressSearch = ({
  onChanged,
  map = false,
  title = 'Galleries',
  isPhotoArtAddressSearch = false
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchBox, setSearchBox] = useState(null);
  const onLoad = setSearchBox;
  const { isLoaded } = useJsApiLoader(getGoogleInitArgs());
  // const [anyFieldFilter, setAnyFieldFilter] = useState(null)

  const onPlacesChanged = () => {
    const place = searchBox.getPlaces();
    onChanged(place);
  };

  // const onAnyFieldFilterChanged = (e) => {
  //   setAnyFieldFilter(e.target.value)
  // }

  const onUploadNewGallery = () => {
    dispatch(setSelectedGallery(null));
    history.push(`/photographer/map/new`);
  }

  const onUploadNewPhoto = () => {
    dispatch(setSelectedGallery(null))
    history.push(`/photographer/photo_art_gallery/new`)
  }


  // useEffect(() => {
  //   dispatch(galleryList.updateListFilter({any_field: anyFieldFilter}))
  //   dispatch(galleryList.fetchListIfNeeded())
  // }, [anyFieldFilter])

  return (
    <>
      {map && (
        <>
          {isLoaded && (
            <StandaloneSearchBox
              onLoad={ onLoad }
              onPlacesChanged={ onPlacesChanged }
            >
              <div className={ classes.mapContainer }>
                <Input
                  type='text'
                  disableUnderline
                  placeholder='Search'
                  className={ classes.mapInput }
                />
              </div>
            </StandaloneSearchBox>
          )}
        </>
      )}
      {!map && (
        <Box className={classes.wrapper}>
          <span className={classes.mainTitle}>{ title }</span>
          {/* {isLoaded && (
            <TextField
            variant='outlined'
            placeholder='Search'
            className={ classes.searchBox }
            onChange={ onAnyFieldFilterChanged }
          />
          )} */}
          {!isPhotoArtAddressSearch &&
           <StyledButton
             variant='contained'
             onClick={ onUploadNewGallery }
           >
             Create New Gallery
           </StyledButton>
          }
          {isPhotoArtAddressSearch &&
           <StyledButton
             variant='contained'
             onClick={ onUploadNewPhoto }
           >
             Load New Photo
           </StyledButton>
          }
        </Box>
      )}
    </>
  )
}
